<pc-sub>
  <script>
    import { notifyLoadDone } from '../vp-notify';
    import tabChannel from '@/worker/tab-channel/top';
    export default {
      onMounted() {
        tabChannel.init();
        notifyLoadDone();
      }
    };
  </script>
</pc-sub>